import React, { useEffect, useState } from "react";
import { PieChart as PieIcon } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { api, fmtINR } from "../lib/api";
import CrudModule from "../components/CrudModule";
import { MODULES } from "../lib/modules";

const COLORS = ["#0B132B", "#1C2541", "#3A506B", "#5BC0BE", "#e11d48", "#f59e0b", "#059669", "#6366f1",
  "#a855f7", "#0891b2", "#84cc16", "#ea580c", "#64748b", "#be123c"];

export default function ExpensesPage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/expense-summary?months=6").then((r) => setD(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm mb-6" data-testid="expense-category-chart">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <PieIcon className="w-5 h-5 text-[#0B132B]" />
            <h2 className="text-base md:text-lg font-semibold text-slate-800 font-head">Where the money went</h2>
          </div>
          <span className="text-xs text-slate-400">last 6 months · total {fmtINR(d?.total || 0)}</span>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-2">
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={d?.months || []} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
                <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
                <YAxis tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}k`} />
                <Tooltip contentStyle={{ background: "#0B132B", border: "none", borderRadius: 4, color: "#fff", fontFamily: "JetBrains Mono", fontSize: 12 }} formatter={(v, n) => [fmtINR(v), n]} cursor={{ fill: "#f8fafc" }} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                {(d?.category_names || []).map((c, i) => (
                  <Bar key={c} dataKey={c} name={c} stackId="cat" fill={COLORS[i % COLORS.length]} maxBarSize={44} />
                ))}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div data-testid="expense-category-table">
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">Category totals</div>
            <div className="space-y-2 max-h-[260px] overflow-y-auto pr-1">
              {(d?.categories || []).length === 0 && <div className="text-sm text-slate-400 py-6 text-center">No expenses recorded yet</div>}
              {(d?.categories || []).map((c, i) => (
                <div key={c.category} data-testid={`expense-cat-${c.category}`} className="flex items-center gap-3">
                  <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: COLORS[i % COLORS.length] }} />
                  <span className="text-sm text-slate-700 flex-1 truncate">{c.category}</span>
                  <span className="text-xs text-slate-400 tabular-nums">{c.percent}%</span>
                  <span className="text-sm font-mono tabular-nums text-slate-900">{fmtINR(c.total)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CrudModule config={MODULES.expenses} />
    </div>
  );
}
